import React from "react";
import Event_section from "./event_section/Event_section";
import News from "./news/News";

function Event() {
  return (
    <>
      <Event_section />
      <News/>
    </>
  );
}

export default Event;
